<template>
  <div class="Dialog prize-result share" v-if="isShowShare">
    <div class="share-box">
        <div class="share-icon-close" @click="closeShare"></div>
        <div class="share-landscape">
            <p v-if="!isInGame">长按保存图片，分享给好友</p>
            <!-- 游戏外分享 -->
            <img class="share-img share-img-sb " :src="picInH5" alt="">
            <!-- 游戏内分享 -->
            <img class="share-img share-img-hb" :src="picInGame" alt="">
            <div class="btn" v-if="isInGame">
                <a :class="['share-btn-l', isQQUser ? 'q-share-btn-l' : '']" @click="shareInGame(1)"></a>
                <a :class="['share-btn-r', isQQUser ? 'q-share-btn-r' : '']" @click="shareInGame(2)"></a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
import * as inGameApi from "../../common/utils/inGame"
import * as userAgent from "../../common/utils/ua"
import * as configs from "../configs"

export default {
  name: "ShareDialog",
  props: ["state"],

  setup(props, { root }) {
    const { $store } = root

    const isShowShare = computed(() => {
      return $store.state.share.isShowShare
    })

    const isInGame = computed(() => {
      return false
      //   return userAgent.getUserAgent().msdk
    })

    const picInH5 = computed(() => {
      return configs?.GAME_INFO?.shareInfo?.H5_PIC
    })

    const picInGame = computed(() => {
      return configs?.GAME_INFO?.shareInfo?.INGAME_PIC
    })

    const isQQUser = computed(() => {
      return props.state.context.loginState.accountType == "qq"
    })

    const closeShare = () => {
      root.$store.commit("SET_IS_SHOW_SHARE", false)
    }

    const shareInGame = type => {
      if (configs?.GAME_INFO?.shareInfo?.INGAME_PIC) {
        if (type == 1) {
          inGameApi.friendShare(configs.GAME_INFO.shareInfo.INGAME_PIC)
        } else {
          inGameApi.quanShare(configs.GAME_INFO.shareInfo.INGAME_PIC)
        }
      }
    }

    return {
      isShowShare,
      isInGame,
      isQQUser,
      picInH5,
      picInGame,
      closeShare,
      shareInGame
    }
  }
}
</script>
